<mat-dialog-content>
  <rpe-registro-actividad-sitio-procesamiento-form [formInput]="sitioProcesamiento"
    (formStatusChanges)="formStatusChange($event)"
    (formValueChanges)="formValueChange($event)"></rpe-registro-actividad-sitio-procesamiento-form>
  <div class="action">
    <button (click)="onCancel()" mat-raised-button>
      Cerrar
    </button>
    <button (click)="onAdd()" mat-raised-button>
      Registrar
    </button>
  </div>
</mat-dialog-content>
